(function() {
  angular.module('cfn').controller('plantProtectantCoreController', [
    '$scope',
    '$rootScope',
    'CoreREST',
    'PlantProtectant',
    '$http',
    '$timeout',
    '$log',
    '$dialog',
    '$injector',
    '$route',
    'FavoriteService',
    'i18nFilter',
    function(
      $scope,
      $rootScope,
      CoreREST,
      PlantProtectant,
      $http,
      $timeout,
      $log,
      $dialog,
      $injector,
      $route,
      FavoriteService,
      i18nFilter
    ) {
      var mode = {
        name: 'plantProtectant',
        hasActive: true
      };

      var ctrl = this;
      ctrl.getEntityName = function() {
        try {
          return $scope.details.plantProtectant.tradeName;
        } catch (e) {
          return '';
        }
      };

      var specialAdd = (mode.specialAdd = []);
      var ele = null;
      ele = {};
      ele.property = 'sysPlantProtectant_restrictions';
      ele.Property = 'SysPlantProtectant_restrictions';
      ele.editable = true;
      specialAdd.push(ele);

      // validation engine
      var vgi = {};
      vgi['active'] = '1';
      vgi['number'] = '1';
      vgi['tradeName'] = '1';
      vgi['unit'] = '1';
      vgi['stockyardDisplayUnit'] = '1';
      vgi['netPrice'] = '2';
      vgi['costs'] = '2';
      vgi['scope'] = '3';
      vgi['agent'] = '3';
      vgi['approvedForFruits'] = '3';
      vgi['approvalNumber'] = '3';
      vgi['sysPlantProtectant_restrictions'] = '3';
      mode.vgi = vgi;

      return coreCommonController(
        'plantProtectant',
        ctrl,
        mode,
        $scope,
        $rootScope,
        CoreREST,
        PlantProtectant,
        $http,
        $timeout,
        $log,
        $dialog,
        $injector,
        $route,
        FavoriteService,
        i18nFilter
      );
    }
  ]);
})();
